import { observer } from 'mobx-react';
import * as React from 'react';

import { SelectFilterWithSearch } from 'components/Filter/DefaultFilters';

import { distanceStore } from '../stores';

type Props = {
  value: nil | string | number;
} & FilterProps;

@observer
class WaveIdComponent extends React.Component<Props> {
  options = () => {
    const distanceModel = distanceStore.modelSelected;

    if (!distanceModel) {
      return [];
    }

    return distanceModel.relationForSelect('waves');
  };

  render() {
    const { props } = this;
    return <SelectFilterWithSearch {...props} options={this.options()} />;
  }
}

export const waveId: FilterListDescriptor = {
  filter: {
    persistance: {
      handler: '=',

      calcValue: function (name, value) {
        return value;
      },

      prettify: function (name, value) {
        const distance = distanceStore.modelSelected;

        if (!distance) {
          return null;
        }

        const waveModel = distance.findRelationModelValue('waves', +value);
        return waveModel && waveModel.label();
      },
    },
  },
  frontend: {
    type: 'custom',
    component: WaveIdComponent,
  },
};
